import { render, staticRenderFns } from "./ServiceCell.vue?vue&type=template&id=2232a9e6&scoped=true"
import script from "./ServiceCell.vue?vue&type=script&lang=ts"
export * from "./ServiceCell.vue?vue&type=script&lang=ts"
import style0 from "./ServiceCell.vue?vue&type=style&index=0&id=2232a9e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232a9e6",
  null
  
)

export default component.exports